import { put, retry, takeEvery } from 'redux-saga/effects';
import ActionTypes from '../../../../Data/ActionTypes';
import getLegalStatementQuery from './getLegalStatementQuery';

/**
 * Worker - requested by below function and carries out any async work
 */
export function* getLegalStatementWorker(action) {
  const maxTries = 3; // 3 retries
  const delayLength = 3000; // 3 seconds

  const {
    localeCode,
    subcategoryId,
    supplierId,
    newsletters,
    includeSupplierLegalStatements,
  } = action.payload;
  try {
    const requestArguments = {
      legalStatement: {
        localeCode,
        subcategoryId,
        supplierId,
        newsletters,
        includeSupplierLegalStatements,
      },
    };

    const args = {
      variables: requestArguments,
    };

    /**
     * redux-saga retry function https://redux-saga.js.org/docs/api#retrymaxtries-delay-fn-args
     *
     * Will set legalStatement as `fail` until successful - which is good as this should only be called when we need a new legalStatement / want to replace what we have
     */
    const legalStatement = yield retry(
      maxTries,
      delayLength,
      getLegalStatementQuery,
      args
    );

    if (legalStatement) {
      yield put({
        type: 'LEGAL_STATEMENT/setLegalStatement',
        payload: legalStatement,
      });
    } else {
      yield put({
        type: 'LEGAL_STATEMENT/getRequestFailed',
        payload: {
          localeCode,
          subcategoryId,
          supplierId,
          newsletters,
          includeSupplierLegalStatements,
          error: 'No legal statement returned from getLegalStatementQuery',
        },
      });
    }
  } catch (error) {
    yield put({
      type: 'LEGAL_STATEMENT/getRequestFailed',
      payload: {
        localeCode,
        subcategoryId,
        supplierId,
        newsletters,
        includeSupplierLegalStatements,
        error: 'Caught error in getLegalStatementWorker',
      },
    });
  }
}

/**
 * Redux Watcher
 */
export default function* getLegalStatementWatcher() {
  yield takeEvery(ActionTypes.GET_LEGAL_STATEMENT, getLegalStatementWorker);
}
